import axios from "axios";

export const GoogleMeetJoinLink = (id) => {
  return axios.get(`/session-bookings/${id}/join-meeting`);
};
